<template>
	<div class="container">
		<b-overlay
			:show="loading"
			rounded="sm"
		>
			<h1 class="border-bottom d-flex mb-5">
				<span class="mr-auto">Measurement {{ $route.params.id }}</span>
				<button
					class="btn btn-link"
					v-if="!edit"
					@click="edit = true"
				>
					<b-icon icon="pencil"></b-icon>
				</button>
				<span v-else>
					<button
						class="btn btn-link mr-3 text-success"
						@click="save"
						:disabled="Object.keys(changeset).length == 0"
					>
						<b-icon icon="check2"></b-icon>
					</button>
					<button
						class="btn btn-link text-danger"
						@click="edit = false"
					>
						<b-icon icon="x"></b-icon>
					</button>
				</span>
			</h1>
			<div class="row">
				<div class="col-lg-6">
					<FieldGroupCard
						:edit="edit"
						:fields="MEASUREMENT_BASE_FIELDS"
						:record="record"
						title="Base"
						@change="onChange"
					/>
					<FieldGroupCard
						:edit="edit"
						:fields="MEASUREMENT_EVENT_META_FIELDS"
						:record="record"
						title="Event meta"
						@change="onChange"
					/>
					<FieldGroupCard
						:edit="edit"
						:fields="MEASUREMENT_TECHNICAL_FIELDS"
						:record="record"
						title="Technical"
						@change="onChange"
					/>
				</div>
				<div class="col">
					<MeasurementFiles
						:edit="edit"
						:field="f"
						:key="f.field"
						:measurement="record"
						v-for="f in MEASUREMENT_EVENT_FILES_FIELDS"
						@change="onRefresh"
						@download="download"
						@delete="removeFile"
						@upload="uploadFile"
					/>
					<!--<FieldGroupCard
						:record="record"
						:fields="MEASUREMENT_EVENT_FILES_FIELDS"
						title="Event files"
					/>-->
					<FieldGroupCard
						:edit="edit && sharedState.user.info.roles.includes('admin')"
						:record="record"
						:fields="AUDIT_FIELDS_FLAT"
						title="Audit"
						@change="onChange"
					/>
				</div>
			</div>
		</b-overlay>
	</div>
</template>

<script>
import apiClient from '@/apiClient'
import FieldGroupCard from '@/components/FieldGroupCard'
import MeasurementFiles from '@/components/MeasurementFiles'
import {
	MEASUREMENT_BASE_FIELDS,
	MEASUREMENT_EVENT_META_FIELDS,
	MEASUREMENT_EVENT_FILES_FIELDS,
	MEASUREMENT_TECHNICAL_FIELDS,
} from '@/fields/measurement_fields'
import { AUDIT_FIELDS_FLAT } from '@/fields/audit_fields'
import { readFieldFlat } from '@/util'

export default {
	components: { FieldGroupCard, MeasurementFiles },
	data() {
		return {
			MEASUREMENT_BASE_FIELDS,
			MEASUREMENT_EVENT_META_FIELDS,
			MEASUREMENT_EVENT_FILES_FIELDS,
			MEASUREMENT_TECHNICAL_FIELDS,
			AUDIT_FIELDS_FLAT,
			changeset: {},
			edit: false,
			loading: false,
			record: {},
		}
	},
	methods: {
		readFieldFlat,
		async fetchRecord() {
			this.loading = true
			this.record = await apiClient.measurementView(
				this.$route.params.id,
				true
			)
			console.log(this.record)
			this.loading = false
		},
		onChange(fieldWithValue) {
			const f = fieldWithValue.field
			const oldValue = readFieldFlat(this.record, f)
			const newValue = fieldWithValue.value
			if (oldValue !== newValue) {
				this.$set(this.changeset, f, newValue)
			} else {
				this.$delete(this.changeset, f)
			}
		},
		onRefresh() {
			this.fetchRecord()
		},
		async save() {
			console.log(JSON.stringify(this.changeset))
			this.loading = true
			if (this.changeset['audit.group']) {
				await apiClient.measurementChangeGroup(
					this.$route.params.id,
					this.changeset['audit.group']._id
				)
				this.$delete(this.changeset, 'audit.group')
			}
			if (Object.keys(this.changeset).length > 0) {
				await apiClient.measurementEdit(
					Object.assign({ id: this.$route.params.id }, this.changeset)
				)
			}
			this.edit = false
			await this.fetchRecord() // TODO we need this extra call because /measurement/edit does not humanize
			this.loading = false
		},
		async download(apiName) {
			this.loading = true
			await apiClient.downloadFile(apiName, this.$route.params.id)
			this.loading = false
		},
		async uploadFile(apiName, file, tag, creator_id) {
			this.loading = true
			await apiClient.uploadFile(
				apiName,
				this.$route.params.id,
				file,
				tag,
				creator_id
			)
			await this.fetchRecord()
			this.loading = false
		},
		async removeFile(gfsName, id) {
			this.loading = true
			await apiClient.deleteFile(gfsName, this.$route.params.id, id)
			await this.fetchRecord()
			this.loading = false
		},
	},
	watch: {
		$route(to, from) {
			this.fetchRecord()
		},
	},
	mounted() {
		this.fetchRecord()
	},
}
</script>
